import React from 'react';
import { Tag, X } from 'lucide-react';
import { etiquetaColor } from './vigilanciaUtils';

export const EtiquetaChip = ({ texto, onClick, onRemove, active, testid }) => (
  <span
    onClick={onClick}
    title={onClick ? `Filtrar por "${texto}"` : undefined}
    data-testid={testid}
    className={`inline-flex max-w-[14rem] items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-semibold transition-shadow duration-200 ${etiquetaColor(texto)} ${onClick ? 'cursor-pointer hover:shadow-sm' : ''} ${active ? 'ring-2 ring-teal-600/50' : ''}`}
  >
    <Tag size={10} className="shrink-0" />
    <span className="truncate">{texto}</span>
    {onRemove && (
      <button
        type="button" aria-label={`Quitar ${texto}`} data-testid={`${testid}-quitar`}
        onClick={(e) => { e.stopPropagation(); onRemove(); }}
        className="ml-0.5 shrink-0 opacity-60 hover:opacity-100 transition-opacity duration-150"
      >
        <X size={11} />
      </button>
    )}
  </span>
);

export default EtiquetaChip;
